<div class="d-flex login">
    <div class="w-50 d-none d-lg-block">
        <div class="img-container-bg h-100 w-100">
            <img class="h-100 w-100 object-fit-cover" src="./images/login.png" alt="">
        </div>
        <a routerLink="/">
            <div class="img-contanier">
                <img src="./images/logo.png" alt="">
            </div>
        </a>
    </div>
    <div class="w-50 form-section">
        <div class="login-form d-flex flex-column align-items-center h-100 py-5">
            <div class="login-form text-center d-flex flex-column justify-content-center flex-fill">
                <div class="mb-3">
                    <div class="logo-container d-inline-block">
                        <img src="./images/logo.png" alt="">
                    </div>
                    <h2 class="my-5">تسجيل الدخول</h2>
                </div>
                <form class="w-100" [formGroup]="form">
                    <div class="form-group mb-3">
                        <input formControlName="email" type="text" class="form-control"
                            placeholder="قم بإدخال البريد الالكتروني">
                        <div class="form-control-feedback text-end"
                            *ngIf="((form.get('email')?.touched) && (form.get('email')?.invalid))">
                            <small *ngIf="form.get('email')?.errors?.['required']" class="text-danger">
                                هذا الحقل مطلوب
                            </small>
                            <small *ngIf="form.get('email')?.errors?.['email']" class="text-danger">
                                البريد الالكتروني غير صحيح
                            </small>
                        </div>
                    </div>
                    <div class="form-group">
                        <input formControlName="password" type="password" class="form-control"
                            placeholder="كلمة المرور">
                        <div class="form-control-feedback text-end"
                            *ngIf="((form.get('password')?.touched) && (form.get('password')?.invalid))">
                            <small *ngIf="form.get('password')?.errors?.['required']" class="text-danger">
                                هذا الحقل مطلوب
                            </small>
                            <small *ngIf="form.get('password')?.errors?.['minlength']" class="text-danger">
                                يجب أن تكون كلمة المرور أكثر من 6 أحرف
                            </small>
                        </div>
                    </div>
                </form>
                <button class="btn btn-primary w-100 my-3" (click)="onSubmit()">
                    تسجيل الدخول
                </button>
            </div>
        </div>
    </div>
</div>